import * as React from 'react';

import { Container, Wrapper, TopBar } from 'common/components';
import {
  ContentProvider,
  ContentList,
  FiltersForm,
  Sort,
  SearchInput,
  StatusFilter,
} from 'templates/content';
import { DetailsSwitch } from 'templates/details';
import appUrls from 'base/app/urls';
import { translate as t } from 'common/utils/translate';
import { useBlogsList } from '../queries';
import BlogsDetails from './BlogsDetails';
import { createTagString } from 'common/utils/tags';

const fields = {
  search: 'search',
  sort: 'sort',
  filter: 'filter',
};

const BlogsList = () => {
  const { data, isError } = useBlogsList();
  const context = {
    data: data?.values.map((blog) => ({
      ...blog,
      titleSuffix: createTagString(blog),
    })),
    path: {
      details: appUrls.BLOGS.DETAILS,
      list: appUrls.BLOGS.LIST,
    },
  };

  return (
    <Container>
      <ContentProvider {...context}>
        <TopBar title={t('Blogs')}>
          <FiltersForm
            sort={['title', fields.sort]}
            search={['title', fields.search]}
            filter={['status', fields.filter]}
          >
            <Wrapper margin={[0, 0.5]}>
              <SearchInput name={fields.search} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <StatusFilter name={fields.filter} />
            </Wrapper>
            <Wrapper margin={[0, 0.5]}>
              <Sort name={fields.sort} />
            </Wrapper>
          </FiltersForm>
        </TopBar>
        <ContentList isError={isError} />
        <DetailsSwitch>
          <BlogsDetails />
        </DetailsSwitch>
      </ContentProvider>
    </Container>
  );
};

export default BlogsList;
